import type { FC } from "react";

import {
  CAT_GENDER_ICON_MAP,
  type TCatOverviewCardProps,
} from "@/ui/components/data-display/Card/CatOverviewCard/CatOverviewCard.config";
import {
  CatOverviewDetail,
} from "@/ui/components/data-display/Card/CatOverviewCard/CatOverviewDetail";
import { Article, Container, Flex } from "@/ui/components/layout";
import { Button, Pill, PolaroidImage } from "@/ui/components/primitives";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";

export const CatOverviewCard: FC<TCatOverviewCardProps> = ({
  cat,
  image,
  editLabel,
  onEdit,
}) => {
  return (
    <Article
      data-component="CatOverviewCard"
      className="w-full rounded-sys-sm border border-solid border-component-card-base bg-sys-white p-6 shadow-neo-brutal"
    >
      <Flex align="start" justify="between" gap="4">
        <Container className="w-auto mx-0">
          <TextSubtitle tag="h2" size={1} isResponsive={false}>{ cat.name }</TextSubtitle>
          <Pill icon="filledCircleTick" variant="benefit" className="mt-1">{ cat.freshStatus }</Pill>
        </Container>
        <Button variant="tertiary" onClick={onEdit}>{ editLabel }</Button>
      </Flex>

      <Flex align="center" className="mt-4">
        <PolaroidImage image={image} className="w-28 h-32" />
        <Flex direction="column" align="start" gap="2" className="px-4 flex-1">
          <CatOverviewDetail
            icon="cake"
            label="Birthday"
            value={cat.birthday}
          />
          <CatOverviewDetail icon="cat" label="Breed" value={cat.breed} />
          <CatOverviewDetail
            icon={CAT_GENDER_ICON_MAP[cat.gender]}
            label="Sex and neuter status"
            value={cat.neuterStatus}
          />
        </Flex>
      </Flex>
    </Article>
  );
};

CatOverviewCard.displayName = "CatOverviewCard";
